/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportBadgeurs } from '../fn/sites-configuration/export-badgeurs';
import { ExportBadgeurs$Params } from '../fn/sites-configuration/export-badgeurs';
import { exportStationTagsGnlDefinition } from '../fn/sites-configuration/export-station-tags-gnl-definition';
import { ExportStationTagsGnlDefinition$Params } from '../fn/sites-configuration/export-station-tags-gnl-definition';
import { importStationTagsGnlDefinition } from '../fn/sites-configuration/import-station-tags-gnl-definition';
import { ImportStationTagsGnlDefinition$Params } from '../fn/sites-configuration/import-station-tags-gnl-definition';

@Injectable({ providedIn: 'root' })
export class SitesConfigurationService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `importStationTagsGnlDefinition()` */
  static readonly ImportStationTagsGnlDefinitionPath = '/custom/stations/{uid}/opcua/configuration/gnl/{opcuaUid}/import';

  /**
   * Import the tags definitions for a station.
   *
   * Allows to import the tags definitions, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importStationTagsGnlDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importStationTagsGnlDefinition$Response(params: ImportStationTagsGnlDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return importStationTagsGnlDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the tags definitions for a station.
   *
   * Allows to import the tags definitions, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importStationTagsGnlDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importStationTagsGnlDefinition(params: ImportStationTagsGnlDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.importStationTagsGnlDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportStationTagsGnlDefinition()` */
  static readonly ExportStationTagsGnlDefinitionPath = '/custom/stations/{uid}/opcua/configuration/gnl/{opcuaUid}/export';

  /**
   * Export the tags definitions in csv format for a station.
   *
   * Allows to export the tags configuration as CSV File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationTagsGnlDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTagsGnlDefinition$Response(params: ExportStationTagsGnlDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationTagsGnlDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the tags definitions in csv format for a station.
   *
   * Allows to export the tags configuration as CSV File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationTagsGnlDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTagsGnlDefinition(params: ExportStationTagsGnlDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationTagsGnlDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportBadgeurs()` */
  static readonly ExportBadgeursPath = '/custom/badgeurs/export';

  /**
   * Export the badgeurs definitions in xlsx format for all stations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportBadgeurs()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportBadgeurs$Response(params?: ExportBadgeurs$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportBadgeurs(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the badgeurs definitions in xlsx format for all stations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportBadgeurs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportBadgeurs(params?: ExportBadgeurs$Params, context?: HttpContext): Observable<Blob> {
    return this.exportBadgeurs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
